import { Box, Grid, Link, Typography } from '@mui/material'
import React from 'react'
import { Capacitor } from '@capacitor/core'
import LoginImage from '../../image/login_background.png'
import LogoImage from '../../image/logo_dark.png'
import LoginForm from '../login-form/LoginFormContainer'
import {
    Logo,
    Image,
    GridContainer,
    GridLeft,
    LogoContainer,
    FormContainer,
} from './LoginPage.styled'
import messages from './LoginPage.messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { formatVersionForDisplay } from '../../utils/version'
import { useOrganizationSwitchDialog } from '../../hooks/useOrganizationSwitchDialog'

export interface IOwnProps {}

export interface IStateProps {
    isLogged: boolean
}

export interface IDispatchProps {}

export type IProps = IOwnProps & IStateProps & IDispatchProps

const LoginPage: React.FC<IProps> = (props) => {
    const { isLogged } = props

    const intl = useIntl()
    const { selectedOrganization, open: openOrganizationDialog, dialog: organizationDialog } = useOrganizationSwitchDialog()

    if (isLogged) {
        return null
    }

    return (
        <>
        <GridContainer container>
            <GridLeft item xs={6}>
                <LogoContainer>
                    <Logo
                        src={LogoImage}
                        alt={intl.formatMessage({ ...messages.logo })}
                    />
                </LogoContainer>

                <Box>
                    <Box mb={Capacitor.isNativePlatform() ? 4 : 14}>
                        <Typography align='center' variant='h5'>
                            <FormattedMessage {...messages.title} />
                        </Typography>
                    </Box>

                    {/* Native only — web deploys are fixed single-tenant. Shown here
                        (not just in the drawer) so a seller sees, before typing any
                        credentials, which backend they're about to log into. Same
                        visual weight as the fields below it, not a small badge easy
                        to miss. */}
                    {Capacitor.isNativePlatform() && (
                        <Box
                            onClick={openOrganizationDialog}
                            sx={{
                                width: '100%',
                                maxWidth: 280,
                                mx: 'auto',
                                mb: 3,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                border: '1px solid #d4d4d3',
                                borderRadius: '4px',
                                background: '#fff',
                                padding: '11.5px 14px',
                                cursor: 'pointer',
                            }}
                        >
                            <Typography component='span' sx={{ fontSize: 13, color: '#74777a' }}>
                                <FormattedMessage
                                    id='app.components.login-page.organization-label'
                                    defaultMessage='Organization'
                                />
                                {': '}
                                <Typography component='span' sx={{ fontSize: 13, fontWeight: 700, color: '#000' }}>
                                    {selectedOrganization?.name ?? '—'}
                                </Typography>
                            </Typography>
                            <Typography component='span' sx={{ fontSize: 12.5, fontWeight: 700, color: 'primary.main' }}>
                                <FormattedMessage
                                    id='app.components.login-page.organization-change'
                                    defaultMessage='Change'
                                />
                            </Typography>
                        </Box>
                    )}

                    <FormContainer>
                        <LoginForm />
                    </FormContainer>
                </Box>

                <Box pb={'15px'} textAlign='center' position='relative'>
                    {/* <Link
                        color='#7d7d7d'
                        fontSize='14px'
                        href={process.env.REACT_APP_EXTERNAL_LINK || '/'}
                    >
                        {messages.enterApiKey.defaultMessage}
                    </Link> */}

                    <Typography
                        variant='caption'
                        color='textPrimary'
                        sx={{
                            position: 'absolute',
                            bottom: '15px',
                            right: '0',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            opacity: 0.9,
                        }}
                    >
                        {formatVersionForDisplay()}
                    </Typography>
                </Box>
            </GridLeft>

            <Grid item xs={6}>
                <Image
                    src={LoginImage}
                    alt={intl.formatMessage({ ...messages.loginPage })}
                />
            </Grid>
        </GridContainer>

        {organizationDialog}
        </>
    )
}

export default LoginPage
